import ChatInput from '../../../components/shared/chat-input/ChatInput';
import ChatContent from '../chats/ChatContent';
import { useParams } from 'react-router-dom';

const Chats = () => {
	const { id } = useParams()
 
	return (
		<div className='flex flex-col h-[calc(100vh-200px)]'>
			<div className=' justify-center items-center mt-auto mx-auto w-full'>
				{id && <ChatContent />}
				<ChatInput />
			</div>
		</div>

	)
}

export default Chats;